import { render } from "./JfNoData.vue?vue&type=template&id=c8f064fc&scoped=true&ts=true"
import script from "./JfNoData.vue?vue&type=script&lang=ts"
export * from "./JfNoData.vue?vue&type=script&lang=ts"

import "./JfNoData.vue?vue&type=style&index=0&id=c8f064fc&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f064fc"]])

export default __exports__